import { Box, Button, Typography } from "@mui/material";
import { TraderType } from "../../types/Trader/Trader";
import AccountSubAccount from "./AccountSubAccount";
import ShowToken from "./ShowToken";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TraderInfo = ({ trader }: { trader: TraderType }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				gap: "4px",
				flexDirection: "column",
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: "16px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: { xs: "flex-start", sm: "center" },
						alignItems: { xs: "flex-start", sm: "center" },
						width: "fit-content",
						flexDirection: { xs: "column", sm: "row" },
					}}
				>
					<Typography
						variant="body1"
						fontSize="32px"
						sx={{ marginRight: "5px" }}
					>
						{t("general.welcome")}
					</Typography>
					<Typography
						variant="body1"
						fontSize="32px"
						fontWeight="bold"
						sx={{ marginLeft: { xs: "12px", sm: "unset" } }}
					>
						{trader.username}
					</Typography>
				</Box>
				<AccountSubAccount />
				<Box
					sx={{
						position: "relative",
						display: "flex",
						alignSelf: { xs: "flex-end", sm: "unset" },
						justifySelf: { xs: "flex-end", sm: "unset" },
						justifyContent: "flex-end",
						width: "100%",
					}}
				>
					<Button
						variant="contained"
						color="secondary"
						sx={{
							fontFamily: "Work Sans !important",
							textTransform: "none",
							fontWeight: "500",
							borderRadius: "100px",
							fontSize: "16px",
							width: { xs: "100%", sm: "unset" },
						}}
						onClick={() => {
							navigate("/trader/ExpertAdvisor");
						}}
					>
						Donwload EA
					</Button>
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					justifyContent: { xs: "flex-start", sm: "center" },
					alignItems: { xs: "flex-start", sm: "center" },
					width: "fit-content",
					flexDirection: { xs: "column", sm: "row" },
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						width: "fit-content",
					}}
				>
					<Typography
						variant="body1"
						fontSize="12px"
						sx={{ marginRight: "5px" }}
					>
						id:{" "}
					</Typography>
					<Typography
						variant="body1"
						fontSize="12px"
						fontWeight="bold"
					>
						{trader.uid}
					</Typography>
				</Box>
				<Typography
					variant="body1"
					fontSize="12px"
					sx={{
						marginRight: "5px",
						marginLeft: "5px",
						display: { xs: "none", sm: "block" },
					}}
				>
					|
				</Typography>
				<ShowToken />
			</Box>
		</Box>
	);
};

export default TraderInfo;
